import Icon from '@ant-design/icons';
import classNames from 'classnames';
import { useContext, useEffect, useState } from 'react';

import SoundDisableSvg from '@/components/Icon/svgs/sounds-off.svg';
import SoundSvg from '@/components/Icon/svgs/sounds-on.svg';
import HomeContext from '@/context/HomeContext';
import { useModel } from '@/hooks/useModel';
import { getMuteStatus, setMuteStatus } from '@/service/chat';

import { useHomepageContext } from '../HomepageContext';
import styles from './index.less';

interface IProps {
  className?: string;
  iconClassName?: string;
}

const VoiceIcon = (props: IProps) => {
  const { className, iconClassName } = props;
  const { isLogin, mindDetail } = useModel('auth-model', (model) => ({
    isLogin: model.isLogin,
    mindDetail: model.mindDetail
  }));

  const { setContext } = useContext(HomeContext);

  const { homepageData } = useHomepageContext();

  const isMute = !homepageData?.voiceSetting;

  const [isMuteVoice, setMuteVoice] = useState<boolean>(true);

  const setMute = () => {
    const nextStatus = !isMuteVoice;

    setMuteVoice(nextStatus);

    if (!mindDetail?.shadowMindId) return;

    setMuteStatus({ mindId: mindDetail.shadowMindId, status: nextStatus ? 'mute' : 'unmute' });
  };

  const queryMuteStatus = () => {
    if (!mindDetail?.shadowMindId) return;

    getMuteStatus({ mindId: mindDetail.shadowMindId }).then((res) => {
      const { data } = res;

      if (data.code === 0) {
        setMuteVoice(data.data === 'mute');
      }
    });
  };

  useEffect(() => {
    setContext({ voiceMute: isMuteVoice });
  }, [isMuteVoice]);

  useEffect(() => {
    if (mindDetail?.shadowMindId && isLogin) {
      queryMuteStatus();
    }
  }, [mindDetail, isLogin]);

  if (isMute || !isLogin) {
    return null;
  }

  return (
    <div
      className={classNames(styles.buttonItem, className)}
      id="voiceIcon"
      onClick={() => {
        setMute();
      }}
    >
      <Icon
        className={classNames(styles.icon, iconClassName)}
        component={!isMuteVoice ? SoundSvg : SoundDisableSvg}
      />
    </div>
  );
};

export default VoiceIcon;
